import request from "@/utils/request";
import config from "@/utils/config";

let baseApi = config.env.VUE_APP_BRAND === 'COTTI' ? '/cotti-capi' : '/teacat-capi'

export function questionnaireDetailApi(data) {
  return request({
    url: baseApi + "/questionnaire/questionnaireDetail",
    method: "POST",
    data
  });
}

export function submitQuestionnaireApi(data) {
  return request({
    url: baseApi + "/questionnaire/submitQuestionnaire",
    method: "POST",
    data
  });
}